import { getAuthToken } from '../utils/localStorageAuth.ts';

export const defaultHeaders = {
  'Content-Type': 'application/json',
  'X-Authorization': getAuthToken() || '',
}